/**
 * Created by PanJiaChen on 16/11/18.
 */
import pinyin from "pinyin";


/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string')) {
            if ((/^[0-9]+$/.test(time))) {
                // support "1548221490638"
                time = parseInt(time)
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(new RegExp(/-/gm), '/')
            }
        }

        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
        return value.toString().padStart(2, '0')
    })
    return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        )
    }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
    })
    return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
    // returns the byte length of an utf8 string
    let s = str.length
    for (var i = str.length - 1; i >= 0; i--) {
        const code = str.charCodeAt(i)
        if (code > 0x7f && code <= 0x7ff) s++
        else if (code > 0x7ff && code <= 0xffff) s += 2
        if (code >= 0xDC00 && code <= 0xDFFF) i--
    }
    return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
    if (!json) return ''
    return cleanArray(
        Object.keys(json).map(key => {
            if (json[key] === undefined) return ''
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
        })
    ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
    const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
    if (!search) {
        return {}
    }
    const obj = {}
    const searchArr = search.split('&')
    searchArr.forEach(v => {
        const index = v.indexOf('=')
        if (index !== -1) {
            const name = v.substring(0, index)
            const val = v.substring(index + 1, v.length)
            obj[name] = val
        }
    })
    return obj
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
    const div = document.createElement('div')
    div.innerHTML = val
    return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
    if (typeof target !== 'object') {
        target = {}
    }
    if (Array.isArray(source)) {
        return source.slice()
    }
    Object.keys(source).forEach(property => {
        const sourceProperty = source[property]
        if (typeof sourceProperty === 'object') {
            target[property] = objectMerge(target[property], sourceProperty)
        } else {
            target[property] = sourceProperty
        }
    })
    return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
    if (!element || !className) {
        return
    }
    let classString = element.className
    const nameIndex = classString.indexOf(className)
    if (nameIndex === -1) {
        classString += '' + className
    } else {
        classString =
            classString.substr(0, nameIndex) +
            classString.substr(nameIndex + className.length)
    }
    element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
    if (type === 'start') {
        return new Date().getTime() - 3600 * 1000 * 24 * 90
    } else {
        return new Date(new Date().toDateString())
    }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function() {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function(...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
    if (!source && typeof source !== 'object') {
        throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
        if (source[keys] && typeof source[keys] === 'object') {
            targetObj[keys] = deepClone(source[keys])
        } else {
            targetObj[keys] = source[keys]
        }
    })
    return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
    return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536) + ''
    return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
    if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
    if (hasClass(ele, cls)) {
        const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
        ele.className = ele.className.replace(reg, ' ')
    }
}
export function htmlBorder(str) {
    const div = document.createElement('div')
    div.innerHTML = str;
    const lists = div.querySelectorAll('table') || [];
    lists.forEach(v=> {
        const t = v.getAttribute('border');
        if (t !== '1') {
            v.setAttribute('border', '1')
            v.setAttribute('style', 'font-size:12px;border-collapse: collapse;')
        }
    });
    return div.innerHTML;
}
/**
 * 处理数据精度问题
 * @param {*} num
 * @param {*} precision
 * @returns
 */
export function numStrip(num, precision = 12) {
    if (typeof num !== "number") {
        throw new Error('请传入数字:'+num);
    }
    return +parseFloat(num.toPrecision(precision));
}
/**
 * 设置剪切板里的内容
 * @returns
 */
export function setClipboard(text) {
    return new Promise((resolve, reject)=> {
        try {
            if (navigator.clipboard && !!text) {
                navigator.clipboard.writeText(text)
                    .then((clipText) => {
                        resolve(clipText)
                    });
            }else {
                throw new Error('请升级浏览器版本后重试')
            }
        } catch (error) {
            reject(error)
        }
    })
}
/**
 * 获取剪切板里的内容
 * @returns
 */
export function getClipboard() {
    return new Promise((resolve, reject)=> {
        try {
            if (navigator.clipboard) {
                navigator.clipboard
                    .readText()
                    .then((clipText) => {
                        resolve(clipText)
                    });

            }else {
                var tempInput = document.createElement("input");
                tempInput.style = "position: absolute; left: -1000px; top: -1000px";
                document.body.appendChild(tempInput);
                tempInput.focus();
                document.execCommand("paste");
                var clipboardData = tempInput.value;
                document.body.removeChild(tempInput);
                console.log(clipboardData, 'clipboardData');
                resolve(clipboardData)
            }
        } catch (error) {
            reject(error)
        }
    })

};
/**
 * 清除对象的空值
 * @param {*} obj
 */
export function cleanObj(obj) {
    if (Object.prototype.toString.call(obj) !== '[object Object]' ) {
        return obj
    }else {
        const o = {};
        Object.keys(obj).forEach(v=> {
            const d = obj[v]
            if (!['', null, undefined].includes(d)) {
                o[v] = d
            };
        });

        return o;
    }
}

/**
 * 判断是否超过指定宽度
 * ele 指定元素
 * type 事件监听
 * @param {*} obj
 */
export function ellipseShowPromise(ele, addEventListener = false, removeAllRanges= true) {
    return new Promise((resolve, reject) => {
        const box = ele;

        const getPadding = (el) => {
            const style = window.getComputedStyle(el, null);
            const paddingLeft = Number.parseInt(style.paddingLeft, 10) || 0;
            const paddingRight = Number.parseInt(style.paddingRight, 10) || 0;
            const paddingTop = Number.parseInt(style.paddingTop, 10) || 0;
            const paddingBottom = Number.parseInt(style.paddingBottom, 10) || 0;
            return {
                pLeft: paddingLeft,
                pRight: paddingRight,
                pTop: paddingTop,
                pBottom: paddingBottom,
            };
        };

        const checkEllipsis = () => {
            const range = document.createRange();
            range.setStart(box, 0);
            range.setEnd(box, box.childNodes.length);
            const selection = window.getSelection();
            // selection.removeAllRanges()
            // selection.addRange(range);
            if(removeAllRanges) {
                selection.addRange(range);
            }
            const rangeWidth = range.getBoundingClientRect().width; // 所有文字的宽度
            const rangeHeight = range.getBoundingClientRect().height; // 所有文字的高度
            const { pLeft, pRight, pTop, pBottom } = getPadding(box);
            const horizontalPadding = pLeft + pRight;
            const verticalPadding = pTop + pBottom;

            let hasEllipsis = (
                rangeWidth + horizontalPadding > box.offsetWidth ||
                rangeHeight + verticalPadding > box.offsetHeight ||
                range.scrollWidth > box.offsetWidth
            );
            if(removeAllRanges) {
                selection.removeAllRanges()
            }
            resolve(hasEllipsis);
        };
        checkEllipsis()
        addEventListener&&box.addEventListener("resize", checkEllipsis);
    });
}
/**
 * 文件大小转化为对应的字符串
 */
export function formatFileSize(size) {
    const scale = 1024
    const digitList = [ "B",'KB', 'MB', 'GB', 'TB']
    let _integer = size
    let digit = 0
    while((_integer > scale) && (digit< digitList.length -1)) {
        _integer = (_integer/scale).toFixed(2)
        digit++
    }
    return `${_integer}${digitList[digit]}`
};
/**
 * 最大公约数
 * @param  {...any} arr
 * @returns
 */
export function gcdFn (...arr) {
    let data = [].concat(...arr);
    const helperGcd = (x, y) => (!y ? x : gcdFn(y, x % y));
    return data.reduce((a, b) => helperGcd(a, b));
};
/**
 * 获取最小质数
 * @param  {...any} arr
 * @returns
 */
export function getPrimeNum(...arr) {
    const max = gcdFn(...arr);
    return arr.map(v=>v/max)
};
/**
 * iframe 方式下载文件
 * @param {*} path 文件全路径
 */
export function iframeDownloadFile(path) {
    const iframe = document.createElement("iframe");
    iframe.src = path;
    iframe.style.display = "none";
    iframe.style.height = 0;
    document.body.appendChild(iframe);
    setTimeout(iframe.remove);
}

export const setStorage = (type, key, value) => {
    window[type].setItem(key, JSON.stringify(value))
}

export const getStorage = (type, key) => {
    const value = window[type].getItem(key)
    if (value) {
        const val = JSON.parse(value)
        return val
    } else {
        return value
    }
}

export const removeStorage = (type, key) => {
    window[type].removeItem(key)
}

/**
 * 显示错误提示并自动消失，或仅滚动到目标位置
 * @param {Object} options - 配置选项
 * @param {string|string[]} options.selectors - 要查找的label选择器，可以是单个选择器或选择器数组
 * @param {string} [options.errorText] - 错误提示文字，不传或为空则只滚动不显示错误信息
 * @param {number} [options.duration=6000] - 提示显示时间(毫秒)，默认6秒
 */
export const wordToPinyin = (text) => {
    return pinyin(text,{style:'normal'}).map(item=>item.join(''));
};


/**
 * 显示错误提示并自动消失，或仅滚动到目标位置
 * @param {Object} options - 配置选项
 * @param {string|string[]} options.selectors - 要查找的label选择器，可以是单个选择器或选择器数组
 * @param {string} [options.errorText] - 错误提示文字，不传或为空则只滚动不显示错误信息
 * @param {number} [options.duration=6000] - 提示显示时间(毫秒)，默认6秒
 */
export const showErrorTip = ({ selectors, errorText, duration = 6 * 1000 }) => {
    // 将单个选择器转换为数组
    const selectorArray = Array.isArray(selectors) ? selectors : [selectors];

    // 查找第一个匹配的label元素
    let label = null;
    for (const selector of selectorArray) {
        label = document.querySelector(`label[for="${selector}"]`);
        if (label) break;
    }

    if (!label) return;

    // 如果有错误文本，则显示错误提示
    if (errorText) {
        // 检查是否已存在相同的提示
        const existingTip = label.nextElementSibling?.dataset.append_error_show === 'true';
        if (existingTip) return;

        // 创建错误提示元素
        let p = document.createElement('p');
        p.style.color = '#F56C6C';
        p.style.fontSize = '12px';
        p.style.marginBottom = '5px';
        p.dataset.append_error_show = 'true';
        p.innerHTML = errorText;

        // 插入错误提示
        label.nextElementSibling.appendChild(p);

        // 设置定时器移除提示
        setTimeout(() => {
            if (p && p.parentNode) {
                p.parentNode.removeChild(p);
            }
        }, duration);
    }

    // 滚动到目标元素位置
    const headerHeight = 100;
    const elementPosition = label.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
        top: elementPosition - headerHeight,
        behavior: 'smooth'
    });
}


/**
 * 从URL中获取指定参数的值
 * @param {string} url - 要处理的URL
 * @param {string} paramName - 要获取的参数名
 * @returns {string|null} - 参数值，如果不存在则返回null
 */
export const getUrlParameter = (url, paramName) => {
    // 构建匹配参数的正则表达式
    const pattern = new RegExp(`${paramName}=([^&]+)`);
    const match = url.match(pattern);
    return match ? match[1] : null;
}

/**
 * 修改URL中指定参数的值，如果参数不存在则添加
 * @param {string} url - 要处理的URL
 * @param {string} paramName - 要修改的参数名
 * @param {string} newValue - 参数的新值
 * @returns {string} - 修改后的URL
 */
export const setUrlParameter = (url, paramName, newValue) => {
    // 检查参数是否存在
    const paramValue = getUrlParameter(url, paramName);
    
    if (paramValue) {
        // 替换现有参数的值
        const pattern = new RegExp(`(${paramName}=)[^&]+`);
        return url.replace(pattern, `$1${newValue}`);
    } else {
        // 添加新参数
        if (url.includes('?')) {
            // URL中已有其他参数，使用&连接
            return `${url}&${paramName}=${newValue}`;
        } else {
            // URL中没有参数，使用?开始
            return `${url}?${paramName}=${newValue}`;
        }
    }
}
